module.exports = __webpack_public_path__ + "img/vassar.b12b2329.png";